module.exports = __webpack_public_path__ + "static/media/Zteco.68953927.jpg";